const { ColorPicker, ColorIndicator, Dropdown, SelectControl } = wp.components;
import { __experimentalNumberControl as NumberControl } from '@wordpress/components';
const { useState, useEffect } = wp.element;
const { escapeHTML } = wp.escapeHtml;
const { __ } = wp.i18n;
const { customize } = wp;
import ReactTooltip from 'react-tooltip'

export const BlogigBorder = ( props ) =>  {
    const [ border, setBorder ] = useState(props.value)
    const [ type, setType ] = useState(border.type)
    const [ color, setColor ] = useState(border.color)
    const [ width, setWidth ] = useState(border.width)
    
    const types = [
        { label: __( escapeHTML( "None" ), "blogig" ), value: 'none' },
        { label: __( escapeHTML( "Dotted" ), "blogig" ), value: 'dotted' },
        { label: __( escapeHTML( "Dashed" ), "blogig" ), value: 'dashed' },
        { label: __( escapeHTML( "Solid" ), "blogig" ), value: 'solid' }
    ]

    useEffect(() => {
        let newBorder = {
            type: type,
            color: color,
            width: width
        }
        setBorder(newBorder)
        customize.value( props.setting )(newBorder)
    },[type,color,width] );

    function getBackground(color) {
        if( color == null ) return
        if( color.includes('preset') ) {
            return 'var(' + color + ')'
        } else {
            return color
        }
    }

    return (
        <>
            <div className="block-header">
                <span className="customize-control-title">{ customize.settings.controls[props.setting].label }</span>
            </div>
            <div className="control-inner">
                <SelectControl
                    value={ type }
                    options={ types }
                    onChange={ ( newType ) => setType( newType ) }
                />
                { ( type != 'none' ) &&
                    <Dropdown
                        popoverProps={{resize:false,noArrow:false,flip:false,placement:'bottom-end'}}
                        renderToggle={ ( { isOpen, onToggle } ) => (
                            <ColorIndicator 
                                className={ color == null && "null-color" }
                                data-tip={ __( escapeHTML( 'initial' ), 'blogig' ) }
                                colorValue = { getBackground(color) }
                                onClick={ onToggle }
                                aria-expanded={ isOpen }
                            />
                        ) }
                        renderContent={ () => <>
                            <div className="preset-colors">
                                <ul className="preset-colors-inner">
                                    <li className={ ( color == '--blogig-global-preset-color-1' ) && 'active' } data-tip={ __( escapeHTML( 'color 1' ), 'blogig' ) } style ={{background: 'var(--blogig-global-preset-color-1)' }} onClick={()=> setColor('--blogig-global-preset-color-1')}/>
                                    <li className={ ( color == '--blogig-global-preset-color-2' ) && 'active' } data-tip={ __( escapeHTML( 'color 2' ), 'blogig' ) } style ={{background: 'var(--blogig-global-preset-color-2)' }} onClick={()=> setColor('--blogig-global-preset-color-2')}/>
                                    <li className={ ( color == '--blogig-global-preset-color-3' ) && 'active' } data-tip={ __( escapeHTML( 'color 3' ), 'blogig' ) } style ={{background: 'var(--blogig-global-preset-color-3)' }} onClick={()=> setColor('--blogig-global-preset-color-3')}/>
                                    <li className={ ( color == '--blogig-global-preset-color-4' ) && 'active' } data-tip={ __( escapeHTML( 'color 4' ), 'blogig' ) } style ={{background: 'var(--blogig-global-preset-color-4)' }} onClick={()=> setColor('--blogig-global-preset-color-4')}/>
                                    <li className={ ( color == '--blogig-global-preset-color-5' ) && 'active' } data-tip={ __( escapeHTML( 'color 5' ), 'blogig' ) } style ={{background: 'var(--blogig-global-preset-color-5)' }} onClick={()=> setColor('--blogig-global-preset-color-5')}/>
                                    <li className={ ( color == '--blogig-global-preset-color-6' ) && 'active' } data-tip={ __( escapeHTML( 'color 6' ), 'blogig' ) } style ={{background: 'var(--blogig-global-preset-color-6)' }} onClick={()=> setColor('--blogig-global-preset-color-6')}/>
                                </ul>
                            </div>
                            <ColorPicker
                                color={color}
                                onChange={ ( newColor ) => setColor( newColor ) }
                                enableAlpha
                            />
                            <ReactTooltip effect="solid"/>
                        </> }
                    />
                }
            </div>
        </>
    )
}